import { Component, ViewChild } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Table } from 'primeng/table';
import { ToastService } from '../../../../../services/toast.service';
import { DepositoResponsavel } from '../../../../../types/DepositoResponsavel.type';
import { DepositoResponsavelService } from './deposito-responsavel.service';

@Component({
  selector: 'app-deposito-responsavel',
  templateUrl: './deposito-responsavel.component.html',
  styleUrl: './deposito-responsavel.component.css',
  providers: [ConfirmationService]
})
export class DepositoResponsavelComponent {
  @ViewChild('dt') table!: Table;

  registros: DepositoResponsavel[] = [];
  loading: boolean = false;
  totalRecords: number = 0;
  quantidadePorPagina: number = 20;

  constructor(
    private service: DepositoResponsavelService,
    private toastService: ToastService,
    private confirmationService: ConfirmationService
  ) {}

  onLazyLoad(event: any) {
    this.loading = true;
    const sortDirection = event.sortOrder === 1 ? 'asc' : 'desc';
    const sortField = event.sortField || 'id';

    this.service
      .getAll(event.first / event.rows, event.rows, sortField, sortDirection)
      .subscribe({
        next: (data) => {
          this.registros = data.content;
          this.totalRecords = data.totalElements;
        },
        error: (error) => {
          this.loading = false;
          this.toastService.erro('Erro', 'Erro ao buscar os registros: ' + (error.error?.message || error.error));
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  confirmarExclusao(registro: DepositoResponsavel) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir este registro?',
      header: 'Confirmar Exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.service.delete(registro.id).subscribe({
          next: () => {
            this.toastService.sucesso('Exclusão', 'Registro excluído com sucesso.');
            this.recarregar();
          },
          error: (error) => {
            this.toastService.erro('Erro', 'Erro ao excluir: ' + (error.error?.message || error.error));
          }
        });
      }
    });
  }

  recarregar() {
    if (this.table) {
      this.table.first = 0;
      this.onLazyLoad({
        first: 0,
        rows: this.table.rows || 20,
        sortField: this.table.sortField || 'id',
        sortOrder: this.table.sortOrder || 1
      });
    }
  }
}
